"use strict";

var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeClientRects = void 0;
var _makeClientRect = require("./makeClientRect");
var mergeClientRects = function mergeClientRects(clientRects) {
  if (clientRects.length === 0) {
    throw new Error('clientRects should not be empty');
  }
  return (0, _makeClientRect.makeClientRect)({
    bottom: Math.max.apply(Math, _toConsumableArray(clientRects.map(function (rect) {
      return rect.bottom;
    }))),
    left: Math.min.apply(Math, _toConsumableArray(clientRects.map(function (rect) {
      return rect.left;
    }))),
    right: Math.max.apply(Math, _toConsumableArray(clientRects.map(function (rect) {
      return rect.right;
    }))),
    top: Math.min.apply(Math, _toConsumableArray(clientRects.map(function (rect) {
      return rect.top;
    })))
  });
};
exports.mergeClientRects = mergeClientRects;